import Divider from '@segment/matcha/components/Divider';
import * as Section from '@segment/matcha/recipes/Section';
import * as views from './DividerSection.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var DividerSection = function DividerSection() {
  return _jsx(views.StyledSectionBase, {
    variant: "noCopy",
    children: _jsx(Section.Contents, {
      children: _jsx(Divider, {})
    })
  });
};

export default DividerSection;